/* eslint-disable no-console */
import axios from "axios";
import secureStorage from '../controllers/secureStorage.js';

const serverMaintenanceMessage = "Server Under Maintenance. Please contact Baxter XI admin.";
const defaultTimeout = 120000;

var HTTPRequest = {
    async getRequest(endPoint, parameters, requestSource = "BXI-Web", timeout = defaultTimeout){
        var response_data;
        await axios({
            method: 'get',
            url: endPoint,
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': requestSource },
            params: parameters,
            timeout: timeout
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                console.log("getRequest", error)
                secureStorage.setItem("serverRunning", true)
                if (error.code == "ECONNABORTED") {
                  response_data = { error: "Request timed out. Please try a shorter date range or fewer sites." }
                } else if (error == "Error: Network Error" || !error.response) {
                  response_data = { error: "Network Error" }
                //   secureStorage.setItem("serverRunning", false)
                } else if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        console.log("Request ka ulit")

                        await HTTPRequest.getRequest(endPoint, parameters)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.getElementById("logoutButton").click()
                        }
                        response_data = {error: error.response.data.error}
                    } else{
                        response_data = {error: error.response.data.error.join(",")}
                    }
                }
              });

        var developerMode = secureStorage.getItem("developerMode")
        if (developerMode != true) {
            if(endPoint.includes("system_module_categories") || endPoint.includes("access_rights")){
                await axios({
                    method: 'PUT',
                    url: endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': requestSource },
                }).then(function (response) {

                }).catch(async function (error) {
                    var regex = /.*login$/;

                    if (!regex.test(location.href)) {
                        alert("Session is already expired. Please login again.");
                        location.assign(location.origin);
                    }
                });
            }

        }

        return response_data
    },
    async postRequest(endPoint, parameters, requestBody, requestSource = "BXI-Web"){
        var response_data;
        await axios({
            method: 'post',
            url: endPoint,
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': requestSource },
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        console.log("Request ka ulit")
                        await HTTPRequest.postRequest(endPoint, parameters, requestBody, requestSource)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    // console.log(error.response.data.error)
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.getElementById("logoutButton").click()
                        }
                        response_data = {error: error.response.data.error}
                    } else {
                        var errors = [];
                        if (error.response.data.error != undefined) {
                            errors = error.response.data.error
                        } else {
                            if (error.response.statusText != undefined) errors.push(error.response.statusText)
                            if (error.error != undefined) errors.push(error.error)
                        }
                        response_data = {error: errors.join(',')}
                    }
                }
            });
        return response_data;
    },

    async putRequest(endPoint, parameters, requestBody, requestSource = "BXI-Web"){
        var response_data;
        await axios({
            method: 'put',
            url: endPoint,
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': requestSource },
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        //console.log("Request ka ulit")
                        await HTTPRequest.putRequest(endPoint, parameters, requestBody, requestSource)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.getElementById("logoutButton").click()
                        }
                        response_data = {error: error.response.data.error}
                    }
                    else{
                        response_data = {error: error.response.data.error.join(",")}
                    }

                    // response_data = {error: error.response.data.error.join(",")}
                   // console.log(error.response.statusText)
                    // alert(error.response.data.statusText)
                }
            });
        return response_data;
    },

    async destroyRequest(endPoint, parameters, requestBody, requestSource = "BXI-Web"){
        var response_data;
        await axios({
            method: 'delete',
            url: endPoint,
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': requestSource },
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        await HTTPRequest.destroyRequest(endPoint, parameters, requestBody, requestSource)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.getElementById("logoutButton").click()
                        }
                        response_data = {error: error.response.data.error}
                    }
                    else{
                        response_data = {error: error.response.data.error.join(",")}
                    }
                }
            });
        return response_data;
    },

    async authenticate(endPoint){
        // eslint-disable-next-line
        var response_data;
        var bodyFormData = new FormData();
        bodyFormData.set('email', secureStorage.getItem("email"));
        bodyFormData.append('refresh_token', secureStorage.getItem("refreshToken"));
        bodyFormData.append('grant_type', 'refresh_token');
        await axios({
            method: 'post',
            url: endPoint.split("/api")[0] + '/oauth/token',
            headers: {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            data: bodyFormData,
            })
            .then(function (response) {
                response_data = response.data
                secureStorage.setItem("accessToken", response_data["access_token"]);
                secureStorage.setItem("refreshToken", response_data["refresh_token"]);
                secureStorage.setItem("serverRunning", true)
                response_data = {status: "Ok"}
            })
            .catch(function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error == "Error: Network Error") {
                  response_data = {error: "Network Error"}
                } else if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                }
                // eslint-disable-next-line

                // console.log("I AM HERE!!!! <<<<")
                response_data = {error: "Error"}
            });

        return response_data;
    },

    async getRequestThirdParty(endPoint, parameters){

        var config = {
            method: 'get',
            url: endPoint.replace(/['"]+/g, ''),
            headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
        };

        // console.log(config);
        var response_data;
        await axios(config)
            .then(function (response) {
                response_data = response.data
            })
            .catch(function (error) {
                response_data = []
                //console.log(error)
            });

        return response_data
    },
}

export default HTTPRequest;
